(function() {

    angular
        .module('ngmvac')
        .controller('mainCotizadorController', mainCotizadorController);

    mainCotizadorController.$inject = ['$scope', '$window'];

    function mainCotizadorController($scope, $window) {
        var vm = this;

        // vm.menuCotizador = 'H';
        // vm.view = '/cotizador/hoteles';
        vm.disabledCookies = false;

        if (!$window.navigator.cookieEnabled) {
            vm.disabledCookies = true;
        }

        vm.changeMenuItem = function(item){
            console.log(item);
            vm.menuCotizador=item;
            switch (vm.menuCotizador) {
                case 'H':
                    vm.view = '/cotizador/hoteles';
                    break;
                case 'A':
                    vm.view = '/cotizador/autos';
                    break;
                case 'HA':
                    vm.view = '/cotizador/hoteles/autos';
                    break;
                case 'V':
                    vm.view = '/cotizador/vuelos';
                    break;
                case 'VH':
                    vm.view = '/cotizador/vuelos';
                    break;
                case 'T':
                    vm.view = '/cotizador/actividades';
                    break;
                default:
            }
        }
    }
})();
